import api from '@/api/index.js'

const pt_locks = {
  state: {
    loading: false,
    updating: false,
    locks: [],
    createdLock: null,
    error: null
  },

  mutations: {
    SET_PT_LOCKS: (state, locks) => {
      state.locks = locks
      state.loading = false
    },
    SET_PT_LOCKS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_PT_LOCKS_UPDATING: (state, updating) => {
      state.updating = updating
    },
    SET_LOCK_ERROR: (state, error) => {
      state.error = error
    },
    SET_CREATED_LOCK: (state, createdLock) => {
      state.createdLock = createdLock
    }
  },

  actions: {
    LoadPtLocks({commit}, teamID) {
      let query = teamID ? `?teamID=${teamID}` : '';
      commit('SET_PT_LOCKS_LOADING', true)
      return api.get(`pt-locks${query}`)
        .then((response) => {
          commit('SET_PT_LOCKS', response)
          commit('SET_PT_LOCKS_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_PT_LOCKS_LOADING', false)
        })
    },
    LoadInspectorTeamPtLocks({commit}, teamID) {
      commit('SET_PT_LOCKS_LOADING', true)
      return api.get(`inspector-teams/${teamID}/pt-locks`)
        .then((response) => {
          commit('SET_PT_LOCKS', response)
          commit('SET_PT_LOCKS_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_PT_LOCKS_LOADING', false)
        })
    },
    CreatePtLock({commit}, payload) {
      commit('SET_PT_LOCKS_UPDATING', true)
      commit('SET_CREATED_LOCK', null)
      commit('SET_LOCK_ERROR', null)
      return api.post(`inspector-teams/${payload.inspector_team_id}/pt-locks`, payload.data)
        .then((response) => {
          commit('SET_CREATED_LOCK', response.body)
          commit('SET_PT_LOCKS_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_LOCK_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_PT_LOCKS_UPDATING', false)
        })
    },
    DeletePtLock({commit}, payload) {
      commit('SET_LOCK_ERROR', null)
      return api.delete(`inspector-teams/${payload.inspector_team_id}/pt-locks/${payload.mapping_id}`)
        .then((response) => commit('SET_LOCK_ERROR', null))
        .catch((error) => {
          commit('SET_LOCK_ERROR', error)
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  }
}

export default pt_locks
